/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { ISectionStateManager, ISectionArticleList, ISectionArticle } from './contracts'
import { observable, action } from 'mobx'
import { injectable } from 'inversify'
import { injectProperty } from '../../configuration/ServiceLocator'
import ISectionApiClient from '../SectionApiClient/contracts'
import { rejects } from 'assert'

@injectable()
export class SectionStateManager implements ISectionStateManager {
	@observable
	sectionArticleList: ISectionArticleList

	@injectProperty('ISectionApiClient')
	public sectionApiClient!: ISectionApiClient

	/**
	 *
	 */
	constructor () {
		this.sectionArticleList = this.getBlankItem()
	}

	getBlankItem(): ISectionArticleList {
		return {
			total: 0,
			items: [],
		}
	}

	@action setSectionArticleList(response: ISectionArticleList): void {

		this.sectionArticleList = response
	}

	@action getSectionArticles(productCode: string, sectionName: string): Promise<ISectionArticleList> {
		return this.sectionApiClient
			.getSectionArticles(productCode, sectionName)
			.then(response => response)
			.catch(error => {
				console.log(error)
				this.setSectionArticleList({ items: [], total: 0 } as ISectionArticleList)
				throw new Error('An error occured when fetching the Section Articles.')
			})
	}
}
